<template>
	<div id="app">
		<div class="main-loading" v-if="!loaded">
			<svg class="main-loading__image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208.91 200.02"><title>Upmood_Logo_v15</title><g id="Layer_2" data-name="Layer 2"><path fill="#3dbfcd" d="M63.23,64.64A63.22,63.22,0,0,0,22,175.78L43.62,200V188A63.23,63.23,0,1,0,63.23,64.64Zm0,104.6a41.37,41.37,0,1,1,41.37-41.37A41.37,41.37,0,0,1,63.23,169.24Z"/><path fill="#3dbfcd" d="M75.94,125.92H63.82a6.07,6.07,0,0,0-6.14,5.63,12.21,12.21,0,1,0,24.4,0A6.08,6.08,0,0,0,75.94,125.92Z"/><path fill="#3dbfcd" d="M50,125.3c8.83,0,8.84-13.73,0-13.73s-8.85,13.73,0,13.73Z"/><path fill="#3dbfcd" d="M89.79,125.3c8.83,0,8.85-13.73,0-13.73s-8.85,13.73,0,13.73Z"/><circle fill="#3dbfcd" cx="104.6" cy="95.63" r="10.92"/><path fill="#f0cb2a" d="M208.91,63.23a63.24,63.24,0,1,0-43.62,60.11v12.15l22.13-24.79A63,63,0,0,0,208.91,63.23Zm-104.6,0a41.37,41.37,0,1,1,41.37,41.37A41.37,41.37,0,0,1,104.31,63.23Z"/><path fill="#f0cb2a" d="M145.09,70.44H133a6.07,6.07,0,0,0-6.14,5.63,12.21,12.21,0,1,0,24.4,0A6.06,6.06,0,0,0,145.09,70.44Z"/><path fill="#f0cb2a" d="M158.94,69.81c-8.83,0-8.84-13.72,0-13.72s8.85,13.72,0,13.72Z"/><path fill="#f0cb2a" d="M119.12,69.81c-8.83,0-8.85-13.72,0-13.72s8.85,13.72,0,13.72Z"/></g></svg>
			<p class="main-loading__text">Loading</p>
		</div>
		<router-view @mounted="loaded = true"/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			loaded: false
		}
	},

	computed: {
		...mapGetters({
			token: 'getToken'
		})
	}
}
</script>

<style lang="scss" scoped>
#app {
	height: 100%;
	width: 100%;
}
</style>
